import theme from 'config/theme';

export default {
  wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    wordWrap: 'break-word',
    backgroundColor: '#fff',
    gap: '12px',
  },
  itemInner: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    flexWrap: 'wrap',
    fontWeight: 500,
    color: theme.palette.grays.gray700,
  },
  name: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  shortName: {},
  time: {
    fontWeight: 400,
    color: theme.palette.grays.gray400,
  },
};
